module.exports = __webpack_public_path__ + "img/where-to-use-xs.2325296f.png";